import { defineStore } from 'pinia'
import storage from '@/plugins/storage'
import http from '@/plugins/api.js'
import {users ,lookups} from '@/stores'
// import { loading } from '@/plugins/loading'

const CONTACT_ORDER_BY = 'contact/orderBy'
const CONTACT_SORT_DIR = 'contact/sortDir'
const CONTACT_DAYS = 'contact/days'
const CONTACT_STATUS = 'contact/status'
const CONTACT_PAGE_SIZE = 'contact/pageSize'
const CONTACT_SEARCH_TERM = 'contact/searchTerm'

export const contacts = defineStore('contacts',{
  id: 'contacts',
  state: () => ({
    contact: null,
    contacts: [],
    contactsFound: [],
    addressesFound: [],
    phonesFound: [],
    birthdaysFound: [],
    contactAddresses: [],
    contactPhones: [],
    contactEmails: [],
    address: null,
    pageSize: storage.session.getItem(CONTACT_PAGE_SIZE) || 10,
    retrospectiveDay: storage.session.getItem(CONTACT_DAYS) || 0,
    searchTerm: storage.session.getItem(CONTACT_SEARCH_TERM) || '',
    status: storage.session.getItem(CONTACT_STATUS) || '',
    sortDir: storage.session.getItem(CONTACT_SORT_DIR) || 'asc',
    orderBy: storage.session.getItem(CONTACT_ORDER_BY) || '',
    filterBy: 9999,
    filterOptions: [],
    isContactChecked: false,
    income: null,
    isIncomeChecked: false,
    expenses: null,
    isExpenseChecked: false,
    related: null,
    isVendors: false,
    isVendorChecked: false,
    loadingContact: false
    }),
  actions: {
    setStatus(status) {
        this.status = status
        storage.session.setItem(CONTACT_STATUS, status)
      },
      setSearchTerm(text) {
        this.searchTerm = text
        storage.session.setItem(CONTACT_SEARCH_TERM, text)
      },
      setPageSize(pageSize) {
        this.pageSize = pageSize
        storage.session.setItem(CONTACT_PAGE_SIZE, pageSize)
      },
      setRetrospectiveDay(days) {
        this.retrospectiveDay = days
        storage.session.setItem(CONTACT_DAYS, days)
      },
      setSortDir(sortDir) {
        this.sortDir = sortDir
        storage.session.setItem(CONTACT_SORT_DIR, sortDir)
      },
      setOrderBy(orderBy) {
        this.orderBy = orderBy
        storage.session.setItem(CONTACT_ORDER_BY, orderBy)
      },
      setFilterBy(filterBy) {
        this.filterBy = filterBy
      },
      setFilterOptions(data) {
        this.filterOptions = data
      },
      setContactChecked(data) {
        for (let contact of this.contacts.items) {
            if (contact.contact === data.contact) {
              contact.isChecked = data.isChecked
              break
            }
          }
          this.isContactChecked = false
          this.isVendorChecked = false
          let numChecked = 0
          for (let contact of this.contacts.items) {
            if (contact.isChecked) {
              numChecked++
            }
            if (numChecked >= 2) {
              this.isContactChecked = true
              break
            }
            if (numChecked >= 1 && this.isVendors) {
              this.isVendorChecked = true
            }
          }
      },
      addContact(contact) {
        this.contact = JSON.parse(JSON.stringify(contact))
      },
      updateContact(data) {
        if (this.visit !== null && data !== null) {
            switch (data.name) {
              case 'contact':
                this.contact.contact = parseInt(data.value)
                break
              case 'contactType':
                this.contact.contactType = parseInt(data.value)
                break
              case 'isCompany':
                this.contact.isCompany = data.value
                break
              case 'salutation':
                this.contact.salutation = data.value
                break
              case 'insuranceId':
                this.contact.insuranceId = data.value
                break
              case 'insuranceNumber':
                this.contact.insuranceNumber = data.value
                break
              case 'firstName':
                this.contact.firstName = data.value
                break
              case 'lastName':
                this.contact.lastName = data.value
                break
              case 'notes':
                this.contact.notes = data.value
                break
              case 'language':
                this.contact.language = parseInt(data.value)
                break
              case 'timezone':
                this.contact.timezone = parseInt(data.value)
                break
              case 'servicetype':
                this.contact.servicetype = parseInt(data.value)
                break
              case 'isFirm':
                this.contact.isFirm = data.value
                break
            }
          }
      },
      setItem(item) {
        switch (item.type) {
            case 'Address':
              var address = this.contactAddresses.find(x => parseInt(x.contactAddress) === parseInt(item.id))
              address[item.property] = item.value
              break
            case 'Phone':
              var phone = this.contactPhones.find(x => parseInt(x.contactPhone) === parseInt(item.id))
              phone[item.property] = item.value
              break
            case 'Email':
              var email = this.contactEmails.find(x => parseInt(x.contactEmail) === parseInt(item.id))
              email[item.property] = item.value
              break
          }
      },
      addAddress(address) {
        this.contactAddresses.push(address)
      },
      removeAddress(id) {
        this.contactAddresses = this.contactAddresses.filter(x => parseInt(x.contactAddress) !== parseInt(id))
      },
      addPhone(phone) {
        this.contactPhones.push(phone)
      },
      removePhone(id) {
        this.contactPhones = this.contactPhones.filter(x => parseInt(x.contactPhone) !== parseInt(id))
      },
      addEmail(email) {
        this.contactEmails.push(email)
      },
      removeEmail(id) {
        this.contactEmails = this.contactEmails.filter(x => parseInt(x.contactEmail) !== parseInt(id))
      },
      initContacts(data) {
        this.contactsFound = []
        if (data !== undefined && data !== null) {
          this.contactsFound = data
        }
      },
      async lookupContact(search) {
        const r = await http.get(`contact/lookupContact?search=${search}`)
        return r.data
      },
      async getContact(id) {
        const r = await http.get(`contact/contact?id=${id}`)
        this.contact = r.data
        return r.data
      },
      async getFirmContact(id) {
        const r = await http.get(`firm/editFirm?id=${id}`)
        this.contact = r.data
        return r.data
      },
      async getContacts(searchOptions) {
        // const loadingStore = loading()
        // loadingStore.startLoading()
        const r = await http.get('contact/contacts', {params: searchOptions})
        this.contacts = []
        this.isContactChecked = false
        this.isVendorChecked = false
        this.isVendors = false
        if (r.data !== undefined && r.data !== null) {
          if (r.data.items !== undefined && r.data.items !== null) {
            for (let item of r.data.items) {
              item.isChecked = false
            }
            this.contacts = r.data
            
          }
        }
        // loadingStore.stopLoading()
        return r.data
      },
      async saveContact() {
        const r = await http.post('contact/saveContact', this.contact)
        return r.data
      },
      async mergeContacts(ids,firm,user) {
        const r = await http.get(`contact/mergeContacts?ids=${ids}&firm=${firm}&user=${user}`)
        return r.data
      },
      async searchContacts(search) {
        let _contacts = []
        if (search !== undefined && search !== null) {
          if (search.searchterm !== '') {
            let url = ''
            url = `contact/contactSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
            if (search.type !== undefined && search.type !== null) {
              if (search.type !== '') {
                url += '&type=' + search.type
              }
            }
            let data = await http.get(url)
            if (data !== undefined && data !== null) {
              if (data.data !== undefined && data.data !== null) {
                for (let item of data.data) {
                  let name = item.fullName
                  if (search.forUsers !== undefined && search.forUsers !== null) {
                    if (item.emailAddress !== null) {
                      name += ' - ' + item.emailAddress
                    }
                  } else {
                    if (item.phoneNo !== undefined && item.phoneNo !== null) {
                      if (item.phoneNo !== null) {
                        name += ' - ' + item.phoneNo
                      }
                    }
                  }
                  let contact = {
                    id: item.contact,
                    name: name,
                    contact: item.contact,
                    fileAs: item.fileAs,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    phoneNo: item.phoneNo,
                    email: item.emailAddress,
                    userId: item.user
                  }
                  _contacts.push(contact)
                }
              }
            }
            this.contactsFound = []
            if (_contacts !== undefined && _contacts !== null) {
              this.contactsFound = _contacts
            }
          }
        }
        return _contacts
      },
      async searchAddresses(search) {
        let _addresses = []
        if (search !== undefined && search !== null) {
          if (search.searchterm !== '') {
            let url = ''
            if (search.department !== undefined && search.department !== null) {
              url = `contact/addressSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
            } else {
              url = `contact/addressSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
            }
            if (search.type !== undefined && search.type !== null) {
              if (search.type !== '') {
                url += '&type=' + search.type
              }
            }
            let data = await http.get(url)
            if (data !== undefined && data !== null) {
              for (let item of data.data.items) {
                let name = item.fullName
                if (item.addressLines !== undefined && item.addressLines !== null) {
                  if (item.addressLines.length > 40) {
                    name += ' - ' + item.addressLines.substring(0, 37) + '...'
                  } else {
                    name += ' - ' + item.addressLines
                  }
                }
                let address = {
                  id: item.address,
                  name: name,
                  contact: item.contact,
                  fileAs: item.fileAs,
                  firstName: item.firstName,
                  lastName: item.lastName,
                  phoneNo: item.phoneNo,
                  address: item.addressLines
                }
                _addresses.push(address)
              }
            }
            this.addressesFound = []
            if (_addresses !== undefined && _addresses !== null) {
              this.addressesFound = _addresses
            }
          }
        }
        return _addresses
      },
      async searchPhones(search) {
        let _phones = []
        if (search !== undefined && search !== null) {
          if (search.searchterm !== '') {
            let url = ''
            if (search.department !== undefined && search.department !== null) {
              url = `contact/phoneSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
            } else {
              url = `contact/phoneSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
            }
            if (search.type !== undefined && search.type !== null) {
              if (search.type !== '') {
                url += '&type=' + search.type
              }
            }
            let data = await http.get(url)
            if (data !== undefined && data !== null) {
              for (let item of data.data.items) {
                let name = item.fullName
                if (item.phoneNo !== undefined && item.phoneNo !== null) {
                  name += ' - ' + item.phoneNo
                }
                let phone = {
                  id: item.phone,
                  name: name,
                  contact: item.contact,
                  fileAs: item.fileAs,
                  firstName: item.firstName,
                  lastName: item.lastName,
                  phoneNo: item.phoneNo
                }
                _phones.push(phone)
              }
            }
            this.phonesFound = []
            if (_phones !== undefined && _phones !== null) {
              this.phonesFound = _phones
            }
          }
        }
        return _phones
      },
      async getContactAddress(id) {
        const r = await http.get(`contact/contactAddress?id=${id}`)
        this.address = null
        if (r.data !== undefined && r.data !== null) {
          if (r.data !== '') {
            this.address = r.data
          }
        }
        return r.data
      },
      async getContactAddresses(id) {
        this.loadingContact = true
        const r = await http.get(`contact/contactAddresses?id=${id}`)
        this.contactAddresses = []
        if (r.data !== undefined && r.data !== null) {
          if (r.data.items !== null) {
            for (let item of r.data.items) {
              item.isChecked = false
              item.isPrimary = false
              if (item.primary === 'P') {
                item.isPrimary = true
              }
            }
            this.contactAddresses = r.data.items
          }
        }
        this.loadingContact = false
        return r.data
      },
      async getContactPhones(id) {
        this.loadingContact = true
        const r = await http.get(`contact/contactPhones?id=${id}`)
        this.contactPhones = []
        if (r.data !== undefined && r.data !== null) {
          if (r.data.items !== null) {
            for (let item of r.data.items) {
              item.isChecked = false
              item.isPrimary = false
              if (item.primary === 'P') {
                item.isPrimary = true
              }
            }
            this.contactPhones = r.data.items
          }
        }
        this.loadingContact = false
        return r.data
      },
      async getContactEmails(id) {
        this.loadingContact = true
        const r = await http.get(`contact/contactEmails?id=${id}`)
        this.contactEmails = []
        if (r.data !== undefined && r.data !== null) {
          if (r.data.items !== null) {
            for (let item of r.data.items) {
              item.isChecked = false
              item.isPrimary = false
              if (item.primary === 'P') {
                item.isPrimary = true
              }
            }
            this.contactEmails = r.data.items
          }
        }
        this.loadingContact = false
        return r.data
      },
      setCheckedAddress(data) {
        for (let address of this.contactAddresses) {
            if (address.contactAddress === data.contactAddress) {
              address.isChecked = data.isChecked
              break
            }
          }
      },

       async saveAddress(data) {
        const r =  await http.post('contact/saveAddress', data)
        let found = false;
        var lookupsData = lookups();
        var getlookups = lookupsData.lookups;
        let addressTypeName = ''
        for (let lookup of getlookups['AddressType']) {
          if (lookup.id === parseInt(data.addressType)) {
            addressTypeName = lookup.name
            break
          }
        }
        let stateProvinceName = ''
        for (let lookup of getlookups['StateProvince']) {
          if (lookup.id === parseInt(data.stateProvince)) {
            stateProvinceName = lookup.name
            break
          }
        }
        if (data.contactAddress !== 0) {
          for (let address of this.contactAddresses) {
            if (address.contactAddress === data.contactAddress) {
              found = true
              address.addressType = data.addressType
              address.addressTypeName = addressTypeName
              address.addressLines = data.addressLines
              address.city = data.city
              address.stateProvince = data.stateProvince
              address.stateProvinceName = stateProvinceName
              address.postalCode = data.postalCode
              address.country = data.country
              address.addressNote = data.addressNote
              address.isChecked = false
              break
            }
          }
        }
        if (found === false) {
          let newAddress = {
            address: r.data.address,
            addressFull: data.addressLines,
            addressType: data.addressType,
            addressTypeName: addressTypeName,
            city: data.city,
            contact: r.data.contact,
            contactAddress: r.data.contactAddress,
            isShared: false,
            mainAddress: null,
            postalCode: data.postalCode,
            primary: '',
            stateProvince: data.stateProvince,
            stateProvinceName: stateProvinceName,
            isChecked: false
          }
          this.contactAddresses.push(newAddress)
        }
        
      },
      async deleteAddress(data) {
        const r = await http.post('contact/deleteAddress', data)
        let addresses = []
        if (r.data.contact !== -1 && data.contactAddress !== 0) {
          for (let address of this.contactAddresses) {
            address.isChecked = false
            if (address.contactAddress !== data.contactAddress) {
              addresses.push(address)
            }
          }
        }
        this.contactAddresses = addresses
      },
      async setPrimaryAddress(data) {
        await http.get(`contact/setPrimaryAddress?id=${data.id}&contact=${data.contact}`)
        for (let address of this.contactAddresses) {
            address.isChecked = false
            address.primary = ''
            address.isPrimary = false
            if (address.contactAddress === data.id) {
              address.primary = 'P'
              address.isPrimary = true
            }
          }
        },
      setCheckedPhone(data) {
        for (let phone of this.contactPhones) {
            if (phone.contactPhone === data.contactPhone) {
              phone.isChecked = data.isChecked
              break
            }
          }
      },
      async savePhone(data) {
        const r = await http.post('contact/savePhone', data)
        let found = false
        let lookupsData = lookups();
        let getlookups = lookupsData.lookups;
        let phoneTypeName = ''
        for (let lookup of getlookups['PhoneType']) {
          if (lookup.id === parseInt(data.phoneType)) {
            phoneTypeName = lookup.name
            break
          }
        }
        let isPrimary = false
        if (data.contactPhone !== 0) {
          for (let phone of this.contactPhones) {
            if (phone.contactPhone === data.contactPhone) {
              found = true
              phone.phoneType = data.phoneType
              phone.phoneNo = data.phoneNo
              phone.extension = data.extension
              phone.phoneNote = data.phoneNote
              phone.phoneTypeName = phoneTypeName
              phone.isChecked = false
              isPrimary = phone.isPrimary
              break
            }
          }
        }
        if (found === false) {
          isPrimary = r.data.isPrimary
          let newPhone = {
            contactPhone: r.data.contactPhone,
            contact: r.data.contact,
            phone: r.data.phone,
            phoneNo: data.phoneNo,
            extension: data.extension,
            phoneType: data.phoneType,
            phoneTypeName: phoneTypeName,
            phoneNote: data.phoneNote,
            isShared: false,
            primary: '',
            isPrimary: false,
            isChecked: false
          }
          this.contactPhones.push(newPhone)
        }
        if (isPrimary) {
          if (this.contacts !== undefined && this.contacts !== null) {
            if (this.contacts.items !== undefined && this.contacts.items !== null) {
              for (let contact of this.contacts.items) {
                if (contact.contact === r.data.contact) {
                  contact.phoneNo = data.phoneNo
                  break
                }
              }
            }
          }
        }
      },
      async deletePhone(data) {
        const r = await http.post('contact/deletePhone', data)
        let phones = []
        if (r.data.contact !== -1 && data.contactPhone !== 0) {
          for (let phone of this.contactPhones) {
            if (phone.contactPhone !== data.contactPhone) {
              phones.push(phone)
            }
          }
        }
        this.contactPhones = phones
      },
      async setPrimaryPhone(data) {
        await http.get(`contact/setPrimaryPhone?id=${data.id}&contact=${data.contact}`)
        let phoneNo = ''
        for (let phone of this.contactPhones) {
          phone.isChecked = false
          phone.primary = ''
          phone.isPrimary = false
          if (phone.contactPhone === data.id) {
            phone.primary = 'P'
            phone.isPrimary = true
            phoneNo = phone.phoneNo
          }
        }
        if (this.contacts !== undefined && this.contacts !== null) {
          if (this.contacts.items !== undefined && this.contacts.items !== null) {
            for (let contact of this.contacts.items) {
              if (contact.contact === data.contact) {
                contact.phoneNo = phoneNo
                break
              }
            }
          }
        }
      },
      setCheckedEmail(data) {
        for (let email of this.contactEmails) {
            if (email.contactEmail === data.contactEmail) {
              email.isChecked = data.isChecked
              break
            }
          }
      },
      async saveEmail(data) {
        const r = await http.post('contact/saveEmail', data)
        let found = false
        let lookupsData = lookups();
        let getlookups = lookupsData.lookups;
        let emailTypeName = ''
        for (let lookup of getlookups['EmailType']) {
          if (lookup.id === parseInt(data.emailType)) {
            emailTypeName = lookup.name
            break
          }
        }
        let isPrimary = false
        if (data.contactEmail !== 0) {
          for (let email of this.contactEmails) {
            if (email.contactEmail === data.contactEmail) {
              found = true
              email.emailType = data.emailType
              email.emailAddress = data.emailAddress
              email.emailTypeName = emailTypeName
              email.isChecked = false
              isPrimary = email.isPrimary
              break
            }
          }
        }
        if (found === false) {
          isPrimary = r.data.isPrimary
          let newEmail = {
            contactEmail: r.data.contactEmail,
            contact: r.data.contact,
            emailAddress: data.emailAddress,
            emailType: data.emailType,
            emailTypeName: emailTypeName,
            primary: '',
            isPrimary: false,
            isChecked: false
          }
          this.contactEmails.push(newEmail)
        }
        if (isPrimary) {
          if (this.contacts !== undefined && this.contacts !== null) {
            if (this.contacts.items !== undefined && this.contacts.items !== null) {
              for (let contact of this.contacts.items) {
                if (contact.contact === r.data.contact) {
                  contact.emailAddress = data.emailAddress
                  break
                }
              }
            }
          }
        }
      },
      async deleteEmail(data) {
        const r = await http.post('contact/deleteEmail', data)
        let emails = []
        if (r.data.contact !== -1 && data.contactEmail !== 0) {
          for (let email of this.contactEmails) {
            if (email.contactEmail !== data.contactEmail) {
              emails.push(email)
            }
          }
        }
        this.contactEmails = emails
      },
      async setPrimaryEmail(data) {
        await http.get(`contact/setPrimaryEmail?id=${data.id}&contact=${data.contact}`)
        let emailAddress = ''
        for (let email of this.contactEmails) {
          email.isChecked = false
          email.primary = ''
          email.isPrimary = false
          if (email.contactEmail === data.id) {
            email.primary = 'P'
            email.isPrimary = true
            emailAddress = email.emailAddress
          }
        }
        if (this.contacts !== undefined && this.contacts !== null) {
          if (this.contacts.items !== undefined && this.contacts.items !== null) {
            for (let contact of this.contacts.items) {
              if (contact.contact === data.contact) {
                contact.emailAddress = emailAddress
                break
              }
            }
          } else {
            let usersData = users();
            usersData.setUserEmail({Contact: data.contact, EmailAddress: emailAddress})
          }
        } else {
          let usersDataLatest = users();
          usersDataLatest.setUserEmail({ Contact: data.contact, EmailAddress: emailAddress })
        }
      },
      async getRelated(id) {
        const r = await http.get(`contact/related?id=${id}`)
        this.related = null
        if (r.data !== undefined && r.data !== null) {
          if (r.data !== '') {
            for (let item of r.data) {
              item.isChecked = false
            }
            this.related = r.data
          }
        }
        return r.data
      },
      async saveRelated(data) {
        const r = await http.post('contact/saveRelated', data)
        return r.data
      },
      async deleteRelated(id) {
        const r = await http.post(`contact/deleteRelated?id=${id}`)
        return r.data
      },
      async getVendor(id) {
        const r = await http.get(`contact/vendor?id=${id}`)
        this.contact = r.data
        return r.data
      },
      async getVendors( searchOptions) {
        const r = await http.get('contact/vendors', {
            params: searchOptions
          })
        this.contacts = []
        this.isContactChecked = false
        this.isVendorChecked = false
        this.isVendors = true
        if (r.data !== undefined && r.data !== null) {
          if (r.data.items !== undefined && r.data.items !== null) {
            for (let item of r.data.items) {
              item.isChecked = false
            }
            this.contacts = r.data
          }
        }
        return r.data
      },
      async saveVendor(data) {
        const r = await http.post('contact/saveVendor', data)
        return r.data
      },
      async searchVendors(search) {
        let _contacts = []
        if (search !== undefined && search !== null) {
          if (search.searchterm !== '') {
            let url = ''
            if (search.department !== undefined && search.department !== null) {
              url = `contact/vendorSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}&department=${search.department}`
            } else {
              url = `contact/vendorSearch/?firmid=${search.firmid}&searchterm=${search.searchterm}`
            }
            if (search.type !== undefined && search.type !== null) {
              if (search.type !== '') {
                url += '&type=' + search.type
              }
            }
            let data = await http.get(url)
            if (data !== undefined && data !== null) {
              if (data.data.items !== undefined && data.data.items !== null) {
                for (let item of data.data.items) {
                  let name = item.companyName
                  if (item.phoneNo !== undefined && item.phoneNo !== null) {
                    name += ' - ' + item.phoneNo
                  }
                  let contact = {
                    id: item.contact,
                    name: name,
                    contact: item.contact,
                    fileAs: item.companyName,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    phoneNo: item.phoneNo
                  }
                  _contacts.push(contact)
                }
              }
            }
            this.contactsFound = []
            if (_contacts !== undefined && _contacts !== null) {
              this.contactsFound = _contacts
            }
          }
        }
        return _contacts
      },
      async setInactive(ids) {
        const r = await http.get(`contact/setInactive?ids=${ids}`)
        return r.data
      }
    
  }
})

